'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weekAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weekAfter.js
// module id = 384
// module chunks = 1